import React from 'react';

import SelectionModeIcon from '../../icons/SelectionModeIcon';

import IconBadge from './IconBadge';

const CheckboxFieldBadge = ({ field, item }) => {
  if (!item || !item.value || item.value.checked !== 'true') {
    return null;
  }

  return (
    <IconBadge icon={<SelectionModeIcon />} iconName="selectionModeIcon">
      {field.name}
    </IconBadge>
  );
};

export default CheckboxFieldBadge;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-card/badges/CheckboxFieldBadge.js